/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Browsedescription1Inputs */

const zh_learn_browsedescription1 = /** @type {(inputs: Learn_Browsedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览由 StudyOS 创建的公开交互式学习资源、示例和引导式学习体验。`)
};

const en_learn_browsedescription1 = /** @type {(inputs: Learn_Browsedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse public interactive learning resources, examples, and guided learning experiences created with StudyOS.`)
};

const es_learn_browsedescription1 = /** @type {(inputs: Learn_Browsedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora recursos públicos de aprendizaje interactivos, ejemplos y experiencias guiadas creadas con StudyOS.`)
};

/**
* | output |
* | --- |
* | "Browse public interactive learning resources, examples, and guided learning experiences created with StudyOS." |
*
* @param {Learn_Browsedescription1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_browsedescription1 = /** @type {((inputs?: Learn_Browsedescription1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Browsedescription1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_browsedescription1(inputs)
	if (locale === "en") return en_learn_browsedescription1(inputs)
	return es_learn_browsedescription1(inputs)
});
export { learn_browsedescription1 as "learn_browseDescription" }